import { TaskProcessingProcess } from '../types/interfaces/TaskProcessingProcess';

export const TaskProcessingProcessTemplate: TaskProcessingProcess = {
  id: 0,
  name: '',
  description: '',
  statusesTransitions: [],
  closingTaskStatuses: []
};
